// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"337b4cd5","348":"281d51b4","571":"98968250","924":"453a51a8"}[chunkId] + ".chunk.js";
};